import React, { useContext, useEffect } from 'react';
import { FirebaseContext, LocalContext } from 'context';
import { useDelayUnmount } from 'hooks';
import { AnimatePresence, motion } from 'motion/react';
import styled from 'styled-components';
import { Dialog, MagicLinkLoginForm, LoginForm } from 'components';

function ProtectedRoute({ children, sessionId, sessionData }) {
  const { firebase, loading, user } = useContext(FirebaseContext);
  const {
    setShowLoginDialog,
    dialogAnimationTime,
    showMagicLinkDialog,
    setShowMagicLinkDialog,
    magicLinkDialogRef,
    showLoginDialog,
    loginDialogRef
  } = useContext(LocalContext);
  const shouldRenderChild = useDelayUnmount(user, dialogAnimationTime);

  useEffect(() => {
    if (!loading && firebase && !user && !shouldRenderChild) {
      // Check if session requires magic link authentication
      if (sessionData?.loginViaMagicLink) {
        setShowMagicLinkDialog(true);
      } else {
        setShowLoginDialog(true);
      }
    }
  }, [
    loading,
    firebase,
    user,
    shouldRenderChild,
    sessionData,
    setShowLoginDialog,
    setShowMagicLinkDialog
  ]);

  return (
    <>
      <Dialog
        ref={magicLinkDialogRef}
        isVisible={showMagicLinkDialog}
        contentStyle={{ maxWidth: '454px' }}>
        <MagicLinkLoginForm
          sessionId={sessionId}
          // onSuccess={() => setShowMagicLinkDialog(false)}
        />
      </Dialog>
      <Dialog
        ref={loginDialogRef}
        isVisible={showLoginDialog}
        contentStyle={{
          maxWidth: '454px'
        }}>
        <LoginForm />
      </Dialog>
      {!loading && firebase && (user || shouldRenderChild) && children}
      <AnimatePresence>
        {loading && (
          <LoadingSpinnerFullScreenWrapper>
            <LoadingSpinner />
          </LoadingSpinnerFullScreenWrapper>
        )}
      </AnimatePresence>
    </>
  );
}

export const LoadingSpinnerFullScreenWrapper = styled(motion.div).attrs({
  initial: false,
  animate: { opacity: 1 },
  exit: { opacity: 0 }
})`
  align-items: center;
  background-color: #fff;
  display: flex;
  height: 100vh;
  justify-content: center;
  position: absolute;
  top: 0;
  width: 100vw;
  z-index: 1000;
`;

export const LoadingSpinner = styled.span`
  animation: spin 0.8s linear infinite;
  border: 9px solid var(--blue);
  border-radius: 50%;
  border-top-color: transparent;
  height: 8rem;
  position: absolute;
  width: 8rem;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export default ProtectedRoute;
